import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import QuoteDetails from "./QuoteDetails";

const QuoteDetailsModal = ({ open, setOpen, quote }) => {
  return (
    <Dialog className="relative z-10" open={open} onClose={setOpen}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-dark-gray bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full justify-center p-4 text-center items-start sm:p-0">
          <DialogPanel
            transition
            className="relative sm:my-8 sm:w-full sm:max-w-[645px] transform overflow-hidden transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="rounded-[24px] bg-white text-left shadow-xl overflow-hidden">
              <QuoteDetails quote={quote} setDetailsModalOpen={setOpen} />
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default QuoteDetailsModal;
